module.exports = __webpack_public_path__ + "img/ZG81_07.5498d3dc.jpg";